<!--DOCS-->
<!--https://github.com/romainsimon/vue-simple-search-dropdown-->
<template>
    <div class="dropdown" v-if="options">
        <!-- Dropdown Input -->
        <input
            class="dropdown-input"
            :name="name"
            @focus="showOptions()"
            @blur="exit()"
            @keyup="keyMonitor"
            v-model="searchFilter"
            :disabled="disabled"
            :placeholder="placeholder"
            autocomplete="off"
        />
        <!-- Dropdown Menu -->
        <div class="dropdown-content" v-show="optionsShown">
            <div
                class="dropdown-item"
                @mousedown="selectOption(option)"
                v-for="(option, index) in filteredOptions"
                :key="index"
            >
                {{ option.name || option.id || '-' }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Dropdown',
    template: 'Dropdown',
    props: {
        loadSelect: {
            type: String,
            required: false,
        },
        name: {
            type: String,
            required: false,
            default: 'dropdown',
            note: 'Input name',
        },
        options: {
            type: Array,
            required: true,
            default: function() {
                return []
            },
            note: 'Options of dropdown. An array of options with id and name',
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Please select an option',
            note: 'Placeholder of dropdown',
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
            note: 'Disable the dropdown',
        },
        maxItem: {
            type: Number,
            required: false,
            default: 6,
            note: 'Max items showing',
        },
    },
    data() {
        return {
            selected: {},
            optionsShown: false,
            searchFilter: this.loadSelect,
        }
    },
    created() {
        this.$emit('selected', this.selected)
    },
    computed: {
        filteredOptions() {
            const filtered = []
            const regOption = new RegExp(this.searchFilter, 'ig')
            for (const option of this.options) {
                if (
                    (this.searchFilter && this.searchFilter.length < 1) ||
                    option.name.match(regOption)
                ) {
                    if (filtered.length < this.maxItem) filtered.push(option)
                }
            }
            return filtered
        },
    },
    methods: {
        selectOption(option) {
            this.selected = option
            this.optionsShown = false
            this.searchFilter = this.selected.name
            this.$emit('selected', this.selected)
        },
        showOptions() {
            if (!this.disabled) {
                this.searchFilter = ''
                this.optionsShown = true
            }
        },
        exit() {
            if (!this.selected.id) {
                this.selected = {}
                this.searchFilter = ''
            } else {
                this.searchFilter = this.selected.name
            }
            this.$emit('selected', this.selected)
            this.optionsShown = false
        },
        // Selecting when pressing Enter
        keyMonitor: function(event) {
            if (event.key === 'Enter' && this.filteredOptions[0])
                this.selectOption(this.filteredOptions[0])
        },
    },
    watch: {
        searchFilter() {
            if (this.filteredOptions.length === 0) {
                this.selected = {}
            } else {
                this.selected = this.filteredOptions[0]
            }
            this.$emit('filter', this.searchFilter)
        },
    },
}
</script>

<style lang="scss" scoped>
input {
    font-family: sans-serif !important;
    color: #333333;
    font-size: 12px;
    padding: 0 4px;
    border: 1px solid #ddd;
    border-top-color: rgb(221, 221, 221);
    border-top-style: solid;
    border-top-width: 1px;
    border-right-color: rgb(221, 221, 221);
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: rgb(221, 221, 221);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-left-color: rgb(221, 221, 221);
    border-left-style: solid;
    border-left-width: 1px;
    border-image-source: initial;
    border-image-slice: initial;
    border-image-width: initial;
    border-image-outset: initial;
    border-image-repeat: initial;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.dropdown {
    position: relative;
    display: block;
    margin: auto;
    .dropdown-input {
        background: #fff;
        cursor: pointer;
        color: #333;
        display: block;
        width: 100%;
        padding: 12px;
        &:hover {
            background: #f8f8fa;
        }
    }
    .dropdown-content {
        position: absolute;
        background-color: #fff;
        max-height: 248px;
        width: 100%;
        overflow: auto;
        font-size: 16px;
        z-index: 1;
        .dropdown-item {
            color: black;
            font-size: 0.7em;
            line-height: 1em;
            padding: 8px;
            text-decoration: none;
            display: block;
            cursor: pointer;
            &:hover {
                background-color: #e7ecf5;
            }
        }
    }
    .dropdown:hover .dropdowncontent {
        display: block;
    }
}
</style>
